/**
 * SFCC-11498 (ARTICLES-12) — shared Learning Center article URL builders.
 * Single source of truth for the article-detail and topic-filtered listing hrefs
 * so the resource route, the card blocks, and the grid stay in sync (and slugs
 * are encoded consistently with the resource-route fetch path).
 */

const ARTICLES_BASE = "/learning-center/articles";

/** Article detail page: `/learning-center/articles/{slug}`. */
export const articleUrl = (slug: string) =>
  `${ARTICLES_BASE}/${encodeURIComponent(slug)}`;

/** Topic-filtered listing: `/learning-center/articles?topic={slug}`. */
export const topicUrl = (slug: string) =>
  `${ARTICLES_BASE}?topic=${encodeURIComponent(slug)}`;
